import { ReactElement } from 'react'
import { Stack } from '@mui/material'
import { EditableLabel } from '@ui/forms'
import StructuralPlanningDeselectButton from '../StructuralPlanningDeselectButton'

interface Props {
  elementGuid: string
  label: string
  variant?: 'h6' | 'h5' | 'h4' | 'body1' | 'body2'
  onClose?: () => void
}

const StructuralPlanningElementFormHeader = ({
  elementGuid,
  label,
  variant,
  onClose,
}: Props): ReactElement => {
  return (
    <Stack direction="column" spacing={1}>
      <EditableLabel elementGuid={elementGuid} label={label} variant={variant} />
      <StructuralPlanningDeselectButton onClose={onClose} />
    </Stack>
  )
}

export default StructuralPlanningElementFormHeader
